import React from "react";
import {Elements} from "@stripe/react-stripe-js";
import {PrePaymentCardElement} from "../pre-payment-card-element/PrePaymentCardElement";
import {PrePaymentNameOnCard} from "../pre-payment-name-on-card/PrePaymentNameOnCard";
import {PrePaymentCreditCardSubmitButton} from "../pre-payment-submit-button/PrePaymentCreditCardSubmitButton";
import {PaymentForm} from "../../../../model/PaymentForm";
import {PrePaymentFeeCreditCard} from "../../pre-payment-fee-credit-card/PrePaymentFeeCreditCard";
import {PaymentInfo} from "../../../../model/PaymentInfo";
import {PrePaymentAgreementCreditCard} from "../../pre-payment-agreement/PrePaymentAgreementCreditCard";
import {StripeServiceSingleton} from "src/Context";
import {FeeOptionKey} from "../../../../../loan-details/component/FeeSelector";
import {PrePaymentFeeBreakdown} from "../../pre-payment-fee-breakdown/PrePaymentFeeBreakdown";
import {LoanData} from "../../../../../loan-details/model/LoanData";
import {Stripe} from "@stripe/stripe-js";

interface Props {
    suggestedName: string,
    fee: string,
    creditCardFee: string,
    paymentInfo: PaymentInfo,
    disabled: boolean
    selectedFees?: FeeOptionKey[]
    loan?: LoanData
    shouldShowBreakdownForNoSelection?: boolean
    availableFeeForBreakdown?: Array<{key: FeeOptionKey, label: string, amount: string}>
}

interface State {
    cardValidity: boolean;
    formValidity: boolean;
    submitButtonDisabled: boolean;
}

export class PrePaymentCreditCard extends React.Component<Props, State> {

    private readonly stripeService = StripeServiceSingleton;
    private readonly stripePromise: Promise<Stripe>;
    private readonly form = React.createRef<PaymentForm>();
    private readonly name = React.createRef<PrePaymentNameOnCard>();
    private readonly card = React.createRef<PrePaymentCardElement>();

    constructor(p: Props) {
        super(p);
        this.state = {
            cardValidity: false,
            formValidity: false,
            submitButtonDisabled: true
        }
        this.stripePromise = this.stripeService.initStripe(this.props.paymentInfo.stripePublicKey);
    }

    componentDidUpdate = (prevProps: Readonly<any>,
                          prevState: Readonly<State>,
                          snapshot?: any) => {
        if (this.isFormUpdated(prevState)) {
            this.setState({
                submitButtonDisabled: !this.state.cardValidity || !this.state.formValidity
            })
        }
    }

    private isFormUpdated = (prevState: Readonly<State>): boolean => {
        let cardValidityChanged = this.state.cardValidity !== prevState.cardValidity;
        let formValidityChanged = this.state.formValidity !== prevState.formValidity;
        return cardValidityChanged || formValidityChanged;
    };

    private handleFormChange = () => {
        let form = this.form.current as PaymentForm;
        this.setState({
            formValidity: form.checkValidity(),
        })
    }

    private handleCardValidityChange = (cardValidity: boolean) => {
        this.setState({
            cardValidity: cardValidity
        });
    }

    private errorCallback = (message: string): void => {
        this.card.current?.setState({
            errorMessage: message
        });
    }

    public hasErrorMessage = (): boolean => {
        let errorMessage = this.card.current?.state.errorMessage;
        return errorMessage != null && errorMessage.length > 0;
    }

    private shouldShowFeeBreakdown = () => {
        return (this.props.selectedFees && this.props.selectedFees.length > 0 && this.props.loan) ||
               (this.props.shouldShowBreakdownForNoSelection && this.props.loan);
    };

    render() {
        return (

            <>
                <Elements stripe={this.stripePromise}>
                    <form ref={this.form} onChange={this.handleFormChange}>
                        <fieldset disabled={this.props.disabled}>
                            {this.shouldShowFeeBreakdown() ? (
                                <PrePaymentFeeBreakdown
                                    loan={this.props.loan!}
                                    selectedFees={this.props.selectedFees || []}
                                    availableFeeForBreakdown={this.props.availableFeeForBreakdown}
                                    shouldShowBreakdownForNoSelection={this.props.shouldShowBreakdownForNoSelection}
                                />
                            ) : (
                                <PrePaymentFeeCreditCard fee={this.props.fee}/>
                            )}

                            <PrePaymentNameOnCard ref={this.name} suggestedName={this.props.suggestedName}/>

                            <PrePaymentCardElement ref={this.card}
                                                   onCardValidityChanged={this.handleCardValidityChange}/>

                            <PrePaymentAgreementCreditCard/>

                            <PrePaymentCreditCardSubmitButton form={this.form}
                                                              cardElement={this.card.current?.getCardElement()}
                                                              submitButtonDisabled={this.state.submitButtonDisabled}
                                                              errorCallback={this.errorCallback}
                                                              selectedFees={this.props.selectedFees}/>
                        </fieldset>
                    </form>
                </Elements>
            </>
        );
    }

}
